import { accessibilityLabel } from '@components/kit/_support'
import ScrollView from '@components/kit/scroll-view'
import React from 'react'
import Content from '@components/content'
import A1cLabs from './a1c-labs'
import BloodSuggarLog from './blood-sugar-log'
import ExamDocuments from './exam-documents'
import StepsLog from './steps-log'
import SymptomLogGroups from './symptom-log-groups'
import WeightLog from './weight-log'

function HealthTracking({ ...props }) {
  return (
    <ScrollView {...accessibilityLabel('Health Tracking')} {...props}>
      <Content mt='-24'>
        <ExamDocuments />
        <WeightLog />
        <A1cLabs />
        <BloodSuggarLog />
        <StepsLog />
        <SymptomLogGroups />
      </Content>
    </ScrollView>
  )
}

export default HealthTracking
